import React, { useRef } from 'react';
import { LinkButton } from 'fronton-react';
import { UserCircleIcon, IdentificationBadgeIcon, ChevronRightIcon } from '@fronton/icons-react';
import { useClickOutside } from 'components/header-legacy/hooks/use-click-outside';
import { link, linkWrap } from './styles';

export interface EntryMenuProps {
  login: () => void;
  loginPageUrl: string;
  onClose: () => void;
  b2bLoginPageUrl: string;
  loginB2B: () => void;
}

export const EntryMenu = ({ login, loginPageUrl, onClose, b2bLoginPageUrl, loginB2B }: EntryMenuProps) => {
  const tooltipContentRef = useRef(null);

  useClickOutside(tooltipContentRef, onClose);

  return (
    <div ref={tooltipContentRef}>
      <div className={linkWrap}>
        <LinkButton
          size="s"
          className={link}
          withExtraClickZone
          href={loginPageUrl}
          onClick={login}
          data-qa="signin-lk"
          iconLeft={<UserCircleIcon />}
          iconRight={<ChevronRightIcon />}>
          Личный аккаунт
        </LinkButton>
      </div>

      <div className={linkWrap}>
        <LinkButton
          size="s"
          className={link}
          withExtraClickZone
          href={b2bLoginPageUrl}
          onClick={loginB2B}
          data-qa="signin-lk-b2b"
          iconLeft={<IdentificationBadgeIcon />}
          iconRight={<ChevronRightIcon />}>
          Бизнес-аккаунт
        </LinkButton>
      </div>
    </div>
  );
};
